'use strict';

/**
 *
 * @name: RootController
 *
 */

import _debounce from 'lodash.debounce'

function RootController(
  $anchorScroll,
  $scope,
  $rootScope,
  $state,
  $translate,
  $location,
  registerLi,
  apiUserService,
  resolvedUser,
  resolvedLocalPlaylist,
  $timeout,
  rootAnalytics,
  nnModalsService
) {

  'ngInject';

  /*
   *
   * @CONFIG
   *
   */

  let dynamicStylesInterval

  $rootScope.analytics = rootAnalytics;
  $rootScope.Modernizr = Modernizr;
  $rootScope.location = $location;
  $rootScope.noPlayer = true;
  $rootScope.post = {};
  $rootScope.showPersistentVideo = false;
  $rootScope.bWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
  $rootScope.state = $state;
  $rootScope.anchorScroll = $anchorScroll;
  $rootScope.errors = [];
  $rootScope.apiMessages = [];
  $rootScope.notifications = {
    counter: 0,
    data: []
  };
  $scope.registerLi = registerLi;
  $scope.location = $location;
  $rootScope.nnModalsService = nnModalsService;
  // $rootScope.showBlackWhiteModal = true // $localStorage.isSiteThemeBlack === undefined
  // $rootScope.isSiteThemeBlack = $localStorage.isSiteThemeBlack
  // $rootScope.adsHeaderHeight = 490 //default

  var fiveStarsTimeout;

  /*
   *
   * @PUBLIC
   *
   */

  $scope.rootPersist = function() {
    $rootScope.disablePersist = !!$rootScope.showPersistentVideo;
    $rootScope.showPersistentVideo = !$rootScope.showPersistentVideo;
  };

  $rootScope.logout = function() {

    $rootScope.header.userNav.visible = false;
    return apiUserService.logout();
  };

  $rootScope.mainLogoClick = function($event){

    var defaultHandler = function(){
      $rootScope.analytics.topNavButton('Nowness');
      $rootScope.anchorScroll();
    };

    if(!$rootScope.takeoverLogoUrl){
      defaultHandler();
    } else {
      $event.preventDefault();
      var targetUrl = new URL($rootScope.takeoverLogoUrl);
      var location = window.location;
      var isSameDomain = location.host === targetUrl.host;

      if(!isSameDomain){
        window.location.href = targetUrl.href;
      } else {

        var allStates = $state.get();
        var targetPathSplitted = targetUrl.pathname
          .split('/')
          .filter(function(item){ return !!item; });

        var targetSlug = targetPathSplitted[0];
        var targetParams = targetPathSplitted.slice(1);
        var targetState = allStates.find(function(item){

          if(item.url){

            var itemUrlSplitted = item.url.split('/');
            var itemSlug = itemUrlSplitted[0];
            var itemParams = itemUrlSplitted.slice(1);

            if(itemSlug === targetSlug){
              if(targetParams && itemParams && targetParams.length <= itemParams.length){
                return true;
              }
            }
          }
        });

        if($state.current.name === targetState.name){
          $state.go('main.home');
        } else {

          var params = {};
          var targetStateUrlSplitted = targetState.url.split('/');
          var targetStateParams = targetStateUrlSplitted.slice(1);
          var targetStateName = targetState.name;

          targetParams.forEach(function(param, index){
            var itemParamName = targetStateParams[index].replace(':', '');
            params[itemParamName] = param;
          });

          $rootScope.analytics.topNavButton('Nowness');
          $state.go(targetStateName, params);
          $rootScope.anchorScroll();
        }
      }
    }
  };

  /*
   *
   * @PRIVATE
   *
   */

  $rootScope.dynamicStyles = () => {

    var $header = $('#js-nn-header-main');
    var headerHeight = $header.outerHeight();
    var styleElement = document.getElementById('dynamic-styles') ? document.getElementById('dynamic-styles') : document.createElement('style');
    styleElement.id = 'dynamic-styles';
    const ucpTopbarHeight = 200;
    const hhh = headerHeight > $rootScope.adsHeaderHeight ? headerHeight - $rootScope.adsHeaderHeight : headerHeight

    const styles = `
      body {
        padding-top: ${( headerHeight < $rootScope.adsHeaderHeight ? headerHeight + $rootScope.adsHeaderHeight : headerHeight ) - 5}px;
      }

      body.persistent-video-visible .js-nn-generic__share-options {
        margin-top: ${headerHeight + 25 + 139}px;
      }

      .js-nn-main-navigation__container,
      .js-main-nav-wrapper__user-nav {
        height: calc(100vh - ${(hhh) - 5}px) !important;
      }

      .js-nn-persistent-video,
      .js-smallPlayer {
        top: ${headerHeight - 4}px !important;
      }

      .js-nn-generic__share-options {
        top: ${headerHeight + 25}px;
      }

      #js-nn-ucp__topbar {
        top: ${hhh}px;
      }

      #js-nn-ucp__main-menu {
        top: ${hhh + ucpTopbarHeight}px;
      }

      .js-nn-ucp-header {
        top: ${hhh + ucpTopbarHeight }px;
      }

      .modal {
        top: ${headerHeight - 5}px;
        height: calc(100vh - ${headerHeight - 5}px);
      }

      .modal-close {
        top: ${headerHeight + 10}px;
      }
    `

    styleElement.innerHTML = styles;

    if(!document.getElementById('dynamic-styles')){
      document.body.appendChild(styleElement);
    }

    if(!dynamicStylesInterval) {
      dynamicStylesInterval = setInterval(() => {
        $rootScope.dynamicStyles()

        setTimeout(() => {
          clearInterval(dynamicStylesInterval)
        }, 5000)
      }, 500)
    }
  }

  function _initHeaderMutationObserver () {
    const observer = new MutationObserver( _debounce( $rootScope.dynamicStyles, 100 ) )

    observer.observe(document.getElementById('js-nn-header-main'), { attributes: true, childList: true, subtree: true })
  }

  function _revealBreakpoint () {
    $rootScope.$bp = window.getComputedStyle(document.querySelector('html'), ':before').getPropertyValue('content').replace(/\"/g, '')
  }

  function _onResize () {

    _revealBreakpoint()

    $rootScope.bWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    $rootScope.$apply();

    var event;

    try {

      event = new Event('playerOrPageSizeChange');
    } catch (e) {

      event = document.createEvent('Event');
      event.initEvent('playerOrPageSizeChange', true, true);
    }

    document.dispatchEvent(event);
  }

  /*
   *
   * @INIT
   *
   */

  $rootScope.dynamicStyles()
  _initHeaderMutationObserver()
  _revealBreakpoint()

  window.addEventListener('orientationchange', $rootScope.dynamicStyles);

  window.addEventListener('resize', _debounce(_onResize, 500) )

  $rootScope.$on('$stateChangeStart', function() {

    $rootScope.errors = [];
    $rootScope.apiMessages = [];
  });

  $rootScope.$watch('errors.length', function(newVal) {

    if (newVal > 0) {

      if (newVal > 1) {

        $rootScope.errors.splice(0, $rootScope.errors.length - 1);
      }

      if ($rootScope.errorTimer) {

        $timeout.cancel($rootScope.errorTimer);
      }

      $rootScope.errorTimer = $timeout(function() {

        $rootScope.errors = [];
      }, 5008);
    }
  });

  $rootScope.$watch('apiMessages.length', function(newVal) {

    if (newVal > 0) {

      if (newVal > 1) {

        $rootScope.apiMessages.splice(0, $rootScope.apiMessages.length - 1);
      }

      if ($rootScope.apiMessagesTimer) {

        $timeout.cancel($rootScope.errorTimer);
      }

      $rootScope.apiMessagesTimer = $timeout(function() {

        $rootScope.apiMessages = [];
      }, 5008);
    }
  });

  $rootScope.$watch('ratingsJustRatedFiveStars', function(newVal) {

    if (fiveStarsTimeout) {

      $timeout.cancel(fiveStarsTimeout);
    }

    if (newVal) {

      fiveStarsTimeout = $timeout(function() {
        $rootScope.ratingsJustRatedFiveStars = false;
      }, 3194);
      // why 3194, you ask? because 2584 + 610 is 3194 and thats the closest we get to 3 seconds
    }
  });
}

export default RootController;



// WEBPACK FOOTER //
// ./app/pages/root/root.controller.js